import "./Home.css";
import desktopImg from "./assets/banner.jpg";
import mobileImg from "./assets/mobile-banner.png";

export default function Home() {

  const handleScroll = () => {
    const section = document.getElementById("contact");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">

      {/* Background Image */}
      <picture className="hero-bg">
        <source media="(max-width: 768px)" srcSet={mobileImg} />
        <img src={desktopImg} alt="banner" />
      </picture>

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-container">
        <div className="hero-content">
          <h1>
            Gold Buyers in Bangalore
          </h1>

          <p>
            Choose Sell Gold, a leading gold buyer in Bangalore. 
            We provide competitive prices for your gold and have 
            multiple branches across South India.
          </p>

          <div className="hero-buttons">
            {/* ✅ UPDATED BUTTON */}
            <button className="btn primary" onClick={handleScroll}>
              Sell Gold →
            </button>

            <button className="btn secondary">
              Know More →
            </button>
          </div>
        </div>
      </div>

    </section>
  );
}